import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { useContext } from "react";
import { Link } from "react-router-dom";
import { ThemeContext } from "../../hooks/ThemeContext";
import { Palette, TrendingUp, ShoppingBag, Users } from "lucide-react";

const HeroSection = () => {
  const { theme } = useContext(ThemeContext);

  return (
    <section className="relative w-full flex items-center justify-center py-16 px-4 bg-transparent">
      <div className={`relative w-full max-w-6xl rounded-[20px] overflow-hidden ${theme === 'dark' ? 'bg-gradient-to-br from-rose-900/20 via-purple-900/20 to-blue-900/20 border border-white/10' : 'bg-gradient-to-br from-rose-50 via-purple-50 to-blue-50 border border-gray-200'} shadow-2xl`}>
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
          className="relative z-10 flex flex-col items-center justify-center py-20 px-6 text-center"
        >
          <div className="flex items-center gap-3 mb-4">
            <Palette className={`w-8 h-8 ${theme === 'dark' ? 'text-rose-400' : 'text-rose-600'}`} />
            <span className={`text-sm font-semibold uppercase tracking-wider ${theme === 'dark' ? 'text-rose-400' : 'text-rose-600'}`}>
              Marketplace Créative
            </span>
          </div>
          
          <h1 className={`text-4xl sm:text-5xl md:text-6xl font-extrabold tracking-tight mb-6 ${theme === 'dark' ? 'text-white' : 'text-gray-900'}`}>
            Achetez & Vendez des
            <br />
            <span className="text-rose-500">Créations Digitales</span>
          </h1>
          
          <p className={`${theme === 'dark' ? 'text-gray-300' : 'text-gray-700'} text-lg sm:text-xl max-w-3xl mb-8`}>
            Découvrez une plateforme où créateurs et clients se rencontrent. Bannières, logos, illustrations et bien plus encore.
          </p>

          <div className="flex flex-wrap justify-center gap-4 mb-12">
            <Link to="/shop" onClick={() => window.scrollTo(0, 0)} className={`px-8 py-4 rounded-lg ${theme === 'dark' ? 'bg-rose-600 text-white hover:bg-rose-700' : 'bg-rose-600 text-white hover:bg-rose-700'} shadow-lg transition-all hover:scale-105 font-semibold flex items-center gap-2`}>
              <ShoppingBag className="w-5 h-5" />
              Explorer la Boutique
            </Link>
            <Link to="/devenir-createur" onClick={() => window.scrollTo(0, 0)} className={`px-8 py-4 rounded-lg border transition-all hover:scale-105 font-semibold flex items-center gap-2 ${theme === 'dark' ? 'border-white/20 text-white hover:bg-white/10' : 'border-gray-300 text-gray-800 hover:bg-white'}`}>
              <Users className="w-5 h-5" />
              Devenir Créateur
            </Link>
          </div>

          {/* Stats */}
          <div className={`grid grid-cols-1 sm:grid-cols-3 gap-6 w-full max-w-2xl p-6 rounded-xl ${theme === 'dark' ? 'bg-white/5 border border-white/10' : 'bg-white border border-gray-200'}`}>
            <div className="text-center">
              <div className="text-3xl font-bold text-rose-500 mb-1">500+</div>
              <div className={`text-sm ${theme === 'dark' ? 'text-gray-400' : 'text-gray-600'}`}>Créations disponibles</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold text-rose-500 mb-1">100+</div>
              <div className={`text-sm ${theme === 'dark' ? 'text-gray-400' : 'text-gray-600'}`}>Créateurs actifs</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold text-rose-500 mb-1">24/7</div>
              <div className={`text-sm ${theme === 'dark' ? 'text-gray-400' : 'text-gray-600'}`}>Support disponible</div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default HeroSection;
